module.exports = __webpack_public_path__ + "img/tooth_clock.0ced8ff2.svg";